export const receiptsObject = {
    receiptData: null,
    isLoading: false,
    error: null,
};
